export default function(size) {

    this._options.totalMemory = size

    return this;
};
